module.exports = __webpack_public_path__ + "img/5.9ffb9a8.svg";